import React, { useState, Dispatch } from 'react';
import { Col, Row, Form, Tooltip, Button, Modal, Alert, Space } from 'antd';
import { ModalContainer } from './styles';
import {
  EditOutlined,
  CloseOutlined,
  SaveOutlined,
  CarOutlined,
  UserOutlined,
  ShopOutlined,
  HomeOutlined,
} from '@ant-design/icons';
import HorariosDisponiveis from './components/HorariosDisponiveis';
import { EditarOrdemDeColetaServices } from './services/editarOrdemDeColetaServices';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../../../../../../store';
import Swal from 'sweetalert2';
import SelectTransportadora from './components/SelectTransportadora';
import SelectVeiculo from './components/SelectVeiculo';
import moment from 'moment';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../../../../store/ducks/agendamentos/actions';
import SelectMotorista from './components/SelectMotorista';
import SelectCd from './components/SelectCD';

import { IAgendamentos } from '../../../../../../../store/ducks/agendamentos/types';
import TitlePage from 'components/TitlePage';
import { TextLabel } from 'components/TextLabel';

export interface IDhAgendamento {
  dhAgendamento: string;
  prevConclusao: string;
}

const ModalEditarPedido: React.FC<{ record: IAgendamentos }> = ({ record }) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const [form] = Form.useForm();

  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const filter = useSelector((state: ApplicationState) => state.Agendamentos.filter);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);


  const [isModalEditVisible, setIsModalEditVisible] = useState(false);
  const [codVeiculo, setcodVeiculo] = useState<number>(record?.codVeiculo);
  const [codTipoCarroceria, setCodTipoCarroceria] = useState<number>(record?.codTipoCarroceria);
  const [codMotorista, setCodMotorista] = useState<number>(record?.codMotorista);
  const [codCdd, setCodCdd] = useState<number>(record?.codCdd);
  const [codTransportadora, setCodTransportadora] = useState<number>(record?.codTransportadora);

  const [disabledButton, setDisabledButton] = useState<boolean>(false);
  const [selectedHorario, setSelectedHorario] = useState<IDhAgendamento | undefined>();
  const [showhorarios, setShowhorarios] = useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [loadingEdit, setLoadingEdit] = useState<boolean>(false);

  const dataAgendamento = (data: string) => {
    const dataAgendamento = moment(data).format();
    const dataAtual = moment().format();
    if (dataAgendamento > dataAtual) {
      return true;
    }
    return false;
  };

  const handleClick = async () => {
    try {
      setLoadingEdit(true);
      await EditarOrdemDeColetaServices.alterarAgendamento(
        record.codAgendamento,
        record.status,
        codCdd,
        codTransportadora,
        codMotorista,
        codVeiculo,
        codTipoCarroceria,
        selectedHorario?.dhAgendamento
      ).then((res) => {
        Swal.fire({
          title: 'Agendamento atualizado com sucesso!',
          showConfirmButton: false,
          timer: 1500,
          html: '',
          icon: 'success',
        });
        setShowhorarios(false);
        setIsModalEditVisible(false);
        setLoadingEdit(false);
        dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd));
      });
    } catch (error: any) {
      if (error.response.data.Erro) {
        Swal.fire({
          title: 'Opss...',
          html: `${error.response?.data?.Erro}`,
          icon: 'warning',
        });
      } else {
        Swal.fire({
          title: 'Opss...',
          html:
            'Não foi possivel atualizar o agendamento, tente novamente,  se persistir contate o suporte técnico!.',
          icon: 'warning',
        });
      }
    }
  };


  return (
    <>
      <Modal
        centered
        title={<TitlePage>Editar Agendamento n° {record.codAgendamento}</TitlePage>}
        visible={isModalEditVisible}
        onCancel={() => {
          setIsModalEditVisible(false);
          setShowhorarios(false);
          setDisabledButton(false);
          setSelectedHorario(undefined);
          setShowAlert(false);
        }}
        maskClosable={false}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={1150}
        footer={[
          <Space>
            <Button
              type="default"
              onClick={() => {
                setIsModalEditVisible(false);
                setShowhorarios(false);
                setDisabledButton(false);
                setSelectedHorario(undefined);
              }}
              icon={<CloseOutlined />}
            >
              Cancelar
            </Button>

            <Button
              type="primary"
              onClick={() => {
                form.validateFields().then(() => {
                  handleClick();
                });
              }}
              disabled={
                disabledButton ||
                (disabledButton && dataAgendamento(record.dhAgendamento)) ||
                loadingEdit
              }
              icon={<SaveOutlined />}
            >
              Salvar
            </Button>
          </Space>,
        ]}
      >
        <ModalContainer>
          <Form form={form}>
            <Row gutter={24}>
              <Col md={12} sm={24} xs={24}>
                <TextLabel>
                  <HomeOutlined /> Centro de distribuição:
                </TextLabel>
                <SelectCd
                  setShowAlert={setShowAlert}
                  setSelectCd={setCodCdd}
                  setDisabledButton={setDisabledButton}
                  setShowhorarios={setShowhorarios}
                  cddAgendamento={record?.centroDistribuicao}
                />
              </Col>
              <Col md={12} sm={24} xs={24}>
                <TextLabel>
                  <ShopOutlined /> Transportadora:
                </TextLabel>
                <SelectTransportadora
                  nomeTransportadora={record?.transportadora}
                  selectCodTransportadora={setCodTransportadora}
                />
              </Col>
            </Row>
            <br />
            <Row gutter={24}>
              <Col md={12} sm={24} xs={24}>
                <TextLabel>
                  {' '}
                  <CarOutlined /> Veículo:
                </TextLabel>
                <SelectVeiculo
                  setShowAlert={setShowAlert}
                  setCodTipValue={setCodTipoCarroceria}
                  setSelectedVeiculo={setcodVeiculo}
                  setDisabledButton={setDisabledButton}
                  setShowhorarios={setShowhorarios}
                  codTipoCarroceria={codTipoCarroceria}
                  codVeiculo={codVeiculo}
                />
              </Col>
              <Col md={12} sm={24} xs={24}>
                <TextLabel>
                  <UserOutlined /> Motorista:
                </TextLabel>
                <Form.Item name="motorista">
                  <SelectMotorista
                    setSelectedMotorista={setCodMotorista}
                    nomeMotorista={record?.motorista}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24} style={{ marginTop: '20px' }}>
              <Col md={24} sm={24} xs={24}>
                <h4>Data e hora do agendamento:</h4>
                <p>
                  <strong>{moment(record.dhAgendamento).format('LLL')}</strong>
                </p>
                <Tooltip title="Clique para alterar data e/ou horário do agendamento">
                  <div onClick={() => setShowhorarios(true)} style={{ cursor: 'pointer' }}>
                    <span>Se deseja alterar a data e/ou horário do agendamento, clique aqui</span>
                    <EditOutlined style={{ fontSize: 22, padding: '0px 20px' }} />
                  </div>
                </Tooltip>
              </Col>
            </Row>
            {showhorarios && (
              <>
                <div style={{ maxWidth: '650px', margin: '50px auto 30px auto' }}>
                  {showAlert && (
                    <Alert
                      message={
                        <strong>
                          Devido ao tipo de alteração feita, a data e/ou hora do agendamento precisa
                          ser remarcada
                        </strong>
                      }
                      type="warning"
                      showIcon
                    />
                  )}
                </div>
                <HorariosDisponiveis
                  selectHorario={setSelectedHorario}
                  setDisabledButton={setDisabledButton}
                  agendamento={{ ...record, codCdd, codVeiculo, codTipoCarroceria }}
                />
              </>
            )}
          </Form>
        </ModalContainer>
      </Modal>
      <Tooltip
        title={
          record.status === 'EXP'
            ? 'Esse agendamento ja foi expedido, não pode ser editado.'
            : moment(record.dhAgendamento).format() <= moment().format() && !cddAtivo?.editaAgendamentoDoDia
            ? 'Não é possível editar um agendamento com data retroativa.'
            : ''
        }
        placement="left"
        color="#090909"
      >
        <Button
          onClick={() => setIsModalEditVisible(true)}
          disabled={
            record.status !== 'AGE' ||( (moment(record.dhAgendamento).format() <= moment().format() && !cddAtivo?.editaAgendamentoDoDia))
          }
          style={{ display: 'block', width: '100%', border: '1px solid #ddd' }}
          type="text"
          icon={<EditOutlined />}
        >
          Editar
        </Button>
      </Tooltip>
    </>
  );
};

export default ModalEditarPedido;
